import angular from 'angular';
import _ from 'lodash';
import gridHeight from "../core/shared-service/grid-utils";

(function () {
    'use strict';

    angular.module('app.registration_request').component('kissRegistrationRequestList', {
        controller: registrationRequestListCtrl,
        templateUrl: require('./registration-request-list.html')

    });
    registrationRequestListCtrl.$inject = [ 'RegistrationRequestFilter','REGISTRATION_REQUEST','$window' , 'registrationRequestSvc', '$scope'];



    function registrationRequestListCtrl(RegistrationRequestFilter,REGISTRATION_REQUEST ,$window, registrationRequestSvc ,$scope) {
        var ctrl = this;
        ctrl.$scope=$scope
        ctrl.REGISTRATION_REQUEST = REGISTRATION_REQUEST;
        ctrl.registrationRequestSvc=registrationRequestSvc;
        ctrl.getGridHeight = getGridHeight;
        ctrl.exportCsv = exportCsv;
        ctrl.searchRegistrations = searchRegistrations;
        ctrl.clearForm = clearForm;
        ctrl.searchRegistrationCompanies = searchRegistrationCompanies;
        ctrl.convertSort=convertSort;
        ctrl.$onInit = function () {

            var defaultCellTemplate =
            '<a class="grid-cell-link" ui-sref="app.registration_request.detail({ id:row.entity.id })"><div class="ui-grid-cell-contents ui-grid-cursor-pointer" ng-click="grid.appScope.$ctrl.view(row)">{{COL_FIELD CUSTOM_FILTERS}}</div></a>';

            this.searchData = new RegistrationRequestFilter();
            this.statusList = this.REGISTRATION_REQUEST.registration_request.status;
            this.gridOptions = {
                columnDefs: [
                    {
                        name: 'creationDate',
                        displayName: 'registration_request.column.registration_date',
                        headerCellFilter: 'translate',
                        cellTemplate: defaultCellTemplate,
                        cellClass: 'pointer',
                    },
                    {
                        name: 'getNameForList()',
                        displayName: 'registration_request.column.corporateName',
                        headerCellFilter: 'translate',
                        minWidth: '300',
                        cellTemplate: defaultCellTemplate,
                        cellClass: 'pointer',
                    },
                    {
                        name: 'userLastName',
                        displayName: 'registration_request.column.last_name',
                        headerCellFilter: 'translate',
                        cellTemplate: defaultCellTemplate,
                        cellClass: 'pointer',
                    },
                    {
                        name: 'userFisrtName',
                        displayName: 'registration_request.column.first_name',
                        headerCellFilter: 'translate',
                        cellTemplate: defaultCellTemplate,
                        cellClass: 'pointer',
                    },
                    {
                        name: 'userEmail',
                        displayName: 'registration_request.column.mail',
                        headerCellFilter: 'translate',
                        minWidth: '250',
                        cellTemplate: defaultCellTemplate,
                        cellClass: 'pointer',
                    },
                    {
                        name: 'status',
                        displayName: 'link_request.column.status',
                        headerCellFilter: 'translate',
                        minWidth: '250',
                        cellTemplate: defaultCellTemplate,
                        cellClass: 'pointer',
                    },

                ],
                useExternalPagination: true,
                enableGridMenu: false,
                useExternalSorting: true,
                enableSorting: true,
                onRegisterApi: gridApi => {
                this.gridApi = gridApi;
                gridApi.core.on.sortChanged(this.$scope, (grid, sortColumns) => {
                    sortColumns = _.map(sortColumns, col => this.convertSort(col));
                    if (sortColumns && sortColumns.length > 0) {
                        this.searchData.setSort(sortColumns);
                    } else {
                        this.searchData.resetSort();
                    }
                    this.searchRegistrations();
                });
                gridApi.pagination.on.paginationChanged(this.$scope, (newPage, pageSize) => {  
                    this.searchData.setPageSize(pageSize);
                    this.searchData.setPage(newPage - 1);
                    this.searchRegistrations();
                });
               },
            };
        }

        function getGridHeight(gridApi) {
            return gridHeight(gridApi);
        }

        function exportCsv() {
            return  registrationRequestSvc.getRegistrationRequestExport(this.searchData);
        
        }

        function searchRegistrations() {
            return registrationRequestSvc.getRegistrationRequestList(this.searchData).then(
                pageRegistrations => {
                    this.gridOptions.totalItems = pageRegistrations.totalItems;
                    this.gridOptions.data = pageRegistrations.registrations;
                    this.preparedSearchFilter = this.searchData.prepareBeforeSearch();
                },
                (/*error*/) => {
                    this.logger.error('error.search');
                }
            );
        }

        function clearForm() {
            // Reset data
            this.searchData = new RegistrationRequestFilter();
            this.searchRegistrations();
        }

        function searchRegistrationCompanies(value) {
            if (value && value.length >= 3) {
                return registrationRequestSvc.searchRegistrationCompanies(value).then(companies => {

                    return companies;
                });
            }
        }
     
        function  convertSort(col) {
            var columnField = _.find(this.REGISTRATION_REQUEST.registration_request.columnFieldMap, { field: col.field });
            if (col && col.sort) {
                return {
                    direction: angular.uppercase(col.sort.direction),
                    property: columnField ? columnField.property : col.field,
                    priority: col.sort.priority,
                };
            }
            return {};
        }
        
    }
})();
